import React from 'react'
import { Aboutus } from '../component/Aboutus'
import { Footer } from '../layout/Footer'
import { Navigationbar } from '../layout/Navigationbar'

export const Aboutpage = () => {
  return (
    <div>
        <Navigationbar/>
        <Aboutus/>
        <Footer/>
    </div>
  )
}
